// d88a0b5e33a0fc9e3ecff4452e7a717a9acf33cd|kind=parser-js|name=CtaResponse|schemaHash=bf6096079cee953ebd64b8c66114776dcdb288e1

import { setDefinedValue } from '@myre/common-primitives';

export function parseCtaResponseFromJSON(
  _data,
) {
  if (!_data) {
    return _data;
  }

  const result = {};

  setDefinedValue(result, 'success', _data.success);
  setDefinedValue(result, 'message', _data.message);
  setDefinedValue(result, 'data', _data.data);

  return result;
}

export function parseCtaResponseToJSON(
  _data,
) {
  if (!_data) {
    return _data;
  }

  const result = {};

  setDefinedValue(result, 'success', _data.success);
  setDefinedValue(result, 'message', _data.message);
  setDefinedValue(result, 'data', _data.data);

  return result;
}
